/**
 * Build-time switches of the client. They are constants of the build, not settings: a release build cannot turn them
 * back on from the page (no query parameter, storage key or global does).
 *
 * `__FWP_DEV_HOOKS__` and `__FWP_CLEARTEXT__` are defined by vite.config.ts: false only in the Android release build
 * (`vite build --mode android-release`), true in every other Vite build and on the dev server. Outside Vite (Node:
 * vitest, tsx, the server's headless validator) it does not exist and the hooks stay on, as before.
 */
declare const __FWP_DEV_HOOKS__: boolean | undefined;
declare const __FWP_CLEARTEXT__: boolean | undefined;
declare const __FWP_TEST_PROVIDERS__: boolean | undefined;

/**
 * The page's developer and test hooks: the whole page query (`?backend=`, `?dev=1`, `?autoguest=1`, `?battleseed=`,
 * `?perf=1`, `?trace=1`, `?render=`, `?lang=`) and the `window.__fwp` debugging handle. Off in the Android release
 * build, where the minifier drops the code behind them.
 */
export const DEV_HOOKS: boolean = typeof __FWP_DEV_HOOKS__ === 'undefined' ? true : __FWP_DEV_HOOKS__;

/**
 * Whether the build may talk to a server without TLS (http://, ws://: the emulator's 10.0.2.2, a LAN address). Off in
 * the Android release build, whose network security config refuses cleartext: its server setting then accepts
 * https:// and wss:// addresses only (src/client/config.ts normalizeServerAddress `secureOnly`) instead of offering
 * addresses the APK cannot reach.
 */
export const CLEARTEXT_SERVERS: boolean = typeof __FWP_CLEARTEXT__ === 'undefined' ? true : __FWP_CLEARTEXT__;

/**
 * The development providers of the store and the rewarded ads ('dev-test': a purchase or an ad view without Google,
 * credited only by a server that allows it: STORE_DEV_TEST, ADS_DEV_TEST). On in the Vite dev server and the Android
 * debug build only (vite.config.ts); the published web page and the release APK never offer them. Outside Vite
 * (vitest, tools) on, like the other hooks.
 */
export const TEST_PROVIDERS: boolean = typeof __FWP_TEST_PROVIDERS__ === 'undefined' ? true : __FWP_TEST_PROVIDERS__;
